import React from "react";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import "../styles/modalStyles.css";

const CreatorModal = ({ title, isOpen, onClose, onSubmit, initial, extraContent, changeFirstName, changeLastName }) => {
  return (
    <Modal open={isOpen} onClose={onClose} style={{}} className="add-modal">
      <div className="add-modal-content">
        <h3>{title}</h3>
        <div className="add-name">
          <TextField
            style={{ width: 200, marginRight: "0.5em" }}
            label="First name"
            variant="filled"
            fullWidth
            onChange={changeFirstName}
            defaultValue={initial}
          />
          <TextField
            style={{ width: 200, marginRight: "1em" }}
            label="Last name"
            variant="filled"
            fullWidth
            onChange={changeLastName}
            defaultValue={initial}
          />
          <Button variant="contained" style={{ marginRight: "5px" }} color="primary" onClick={onSubmit}>
            Submit
          </Button>
          <Button variant="contained" color="secondary" onClick={onClose}>
            Cancel
          </Button>
        </div>
        {extraContent && <div className="extra-content">{extraContent}</div>}
      </div>
    </Modal>
  );
};

export default CreatorModal;
